module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_06-1897521e11672012627049f8de63d32f.jpg";